import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import TransitionButton from '../molecules/TransitionButton';
import { mypage_url, loan_types } from '../Const';
import { releaseBrowserBack, banBrowserBack } from '../BrowserBack';
import Popup from '../molecules/Popup';
import {
  KWANKGM04270A02,
  KWANKGM04240A02,
  KWANKGM04270A01,
  KWANKGM04240A01,
} from '../const/api_modules';

interface Props {
  is_change: boolean; // 借入申込変更
  movePrevStep: () => void;
  handleClickNext: (function_name: string) => Promise<any>; // 「次へボタン」のアクション
  handleClickTempSave: (function_name: string) => Promise<any>; // 「一時保存」のアクション
  reception_cd: string;
  reception_id: number;
  moveNextStep: VoidFunction;
  setDisplayStatus: (flag: boolean) => void;
  status_code: number;
}

// KWANKGM04270_近代化資金借入申込書_確認
// KWANKGM04240_借入申込希望書兼経営改善資金計画書_確認
const ModernizationFundsFooterBorrowingApplicationInputConfirmation: React.FC<Props> = ({
  is_change,
  movePrevStep,
  handleClickNext,
  handleClickTempSave,
  reception_cd,
  reception_id,
  moveNextStep,
  setDisplayStatus,
  status_code,
}) => {
  const [modal_temp_save, setModalTempSave] = useState(false);
  const history = useHistory();
  // URLパラメータに商品IDが付与されているか
  const url = new URL(window.location.href);
  const item_id = url.searchParams.get('item_id');

  // 『次へボタン』、『申込を完了する』押下時に投げるモジュール名を切り替える
  const getNextButtonModuleName = () => {
    if (item_id === loan_types.business_improvement_financing_plan) {
      return KWANKGM04240A02;
    } else if (item_id === loan_types.modernization_funds) {
      return KWANKGM04270A02;
    } else {
      return '';
    }
  };

  // 『一時保存』ボタン押下時に投げるモジュール名を切り替える
  const getTempSaveModuleName = () => {
    if (item_id === loan_types.business_improvement_financing_plan) {
      return KWANKGM04240A01;
    } else if (item_id === loan_types.modernization_funds) {
      return KWANKGM04270A01;
    } else {
      return '';
    }
  };

  // 『次へボタン』、『申込を完了する』押下時のアクション
  const clickNext = async () => {
    const next_button_module_name = getNextButtonModuleName();
    const result = await handleClickNext(next_button_module_name);
    if (!result) {
      return;
    }
    moveNextStep();
    setDisplayStatus(false);

    history.push({
      pathname: `/reception/${reception_cd}/${reception_id}/${status_code}/complete`,
      search: `?item_id=${item_id}`,
    });
  };

  //「一時保存する」押下時のイベントハンドラ
  const handleClickOpenTempSave = async () => {
    const temp_save_module_name = getTempSaveModuleName();

    // 一時保存の処理（CommonAPIをキックする）
    const result = await handleClickTempSave(temp_save_module_name);
    if (result) {
      setModalTempSave(true);
    }
  };

  /**
   * 一つ前の画面に遷移
   */
  const handleClickReturn = () => {
    movePrevStep();
    releaseBrowserBack();
    history.goBack();
    banBrowserBack();
  };

  return (
    <>
      {item_id === loan_types.modernization_funds && (
        <Row className="mt-5">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <p>
              連帯債務者等の方(連帯債務・連帯保証で設定している方)にこの借入についてあらかじめ連絡しておいて下さい。
              <br />
              「申込を完了する」ボタンを押すと連帯債務者等の方に申込内容確認のためのメールが送信されます。
              <br />
              連帯債務者等がいる場合、連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
              <br />
              連帯債務者等の確認状況はマイページから確認可能です。
            </p>
          </Col>
        </Row>
      )}
      <Row
        className={`mt-5 ${!is_change &&
          'flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse'}`}
      >
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-no-arrow">
          <div className="text-left sp-button-center">
            <a className="btn btn-xl btn-main-color" onClick={handleClickOpenTempSave}>
              一時保存する
            </a>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
          <div className="text-right sp-button-center">
            <a className="btn btn-xl btn-main-color ml-auto" onClick={clickNext}>
              申込を完了する
            </a>
          </div>
        </Col>
      </Row>
      <TransitionButton label="戻る" handleClick={handleClickReturn} />
      <Popup
        title="一時保存完了"
        text="入力内容を一時保存しました。このまま入力を続けますか？"
        first_button={{
          label: '入力を続ける',
          variant: 'success',
          handleClick: () => setModalTempSave(false),
        }}
        second_button={{
          label: 'マイページへ戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalTempSave(false);
            location.href = mypage_url;
          },
        }}
        toggleClose={() => setModalTempSave(false)}
        toggleShow={modal_temp_save}
      />
    </>
  );
};

export default memo(ModernizationFundsFooterBorrowingApplicationInputConfirmation);
